// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconMail, IconLock, IconArrowLeft, IconSparkles } from '@tabler/icons-react';
import { AuthLayoutWrapper, SocialLoginButtons } from '../components';

export default function LoginModern() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', { email, password, rememberMe });
  };

  return (
    <AuthLayoutWrapper variant="modern">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/login"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header with badge */}
        <Stack align="center" gap="xs">
          <Badge
            leftSection={<IconSparkles size={12} />}
            variant="gradient"
            gradient={{ from: 'violet', to: 'cyan' }}
            size="lg"
          >
            Modern Experience
          </Badge>
          <Title order={1} ta="center" mt="md">
            Sign in to your account
          </Title>
          <Text c="dimmed" size="sm" ta="center" maw={300}>
            Welcome back! Enter your credentials to access your dashboard.
          </Text>
        </Stack>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email address"
              placeholder="name@company.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              size="md"
              radius="md"
            />

            <div>
              <PasswordInput
                label="Password"
                placeholder="Enter your password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                size="md"
                radius="md"
              />
              <Group justify="flex-end" mt="xs">
                <Anchor
                  component={Link}
                  to="/demo/auth-pages/forgot-password/modern"
                  size="sm"
                  c="indigo"
                >
                  Forgot password?
                </Anchor>
              </Group>
            </div>

            <Checkbox
              label="Keep me signed in for 30 days"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.currentTarget.checked)}
            />

            <Button
              type="submit"
              fullWidth
              size="md"
              radius="md"
              variant="gradient"
              gradient={{ from: 'indigo', to: 'cyan' }}
            >
              Continue
            </Button>
          </Stack>
        </form>

        {/* Social Login */}
        <SocialLoginButtons
          providers={['google', 'github', 'apple']}
          layout="icons-only"
          dividerLabel="or continue with"
        />

        {/* Register Link */}
        <Text ta="center" size="sm">
          New to our platform?{' '}
          <Anchor component={Link} to="/demo/auth-pages/register/modern" fw={600} c="indigo">
            Create an account
          </Anchor>
        </Text>

        {/* Terms */}
        <Text ta="center" size="xs" c="dimmed">
          By signing in, you agree to our{' '}
          <Anchor size="xs">Terms of Service</Anchor>
          {' '}and{' '}
          <Anchor size="xs">Privacy Policy</Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
